var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card border-0 stand-up-animation animation-shadow shadow rounded img-object-fit",attrs:{"id":"card-303","img-src":_vm.image,"img-alt":_vm.alt,"img-top":""}},[_c('b-row',[_c('b-col',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }